import { render, staticRenderFns } from "./FittingSwingList.vue?vue&type=template&id=2f5dc225&scoped=true&"
import script from "./FittingSwingList.vue?vue&type=script&lang=js&"
export * from "./FittingSwingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5dc225",
  null
  
)

export default component.exports